module Shared.Environments {

    export var module = angular.module("SharedEnvironmentsModule", ["frends-utils"]);
    export const DEFAULT_ENV_NAME = "Default";
}